interface LoadingOrContentProps {
  isLoading: boolean;
  children?: React.ReactNode;
  loader: React.ReactNode;
}

export const LoadingOrContent = ({
  isLoading,
  children,
  loader,
}: LoadingOrContentProps): JSX.Element | null => {
  if (isLoading) {
    return <>{loader}</>;
  }

  if (children != null) {
    return <>{children}</>;
  }

  return null;
};
